"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";

export default function MobileMenu() {
	const router = useRouter();
	const [navigationStack, setNavigationStack] = useState([]);
	const [loading, setLoading] = useState(true);
	const [fullCategoryTree, setFullCategoryTree] = useState([]);
	const [depots, setDepots] = useState([]);

	useEffect(() => {
		fetchCategoryTree();
	}, []);

	useEffect(() => {
		fetch("/api/depozite")
			.then((r) => r.json())
			.then((d) => setDepots(d.depots || []))
			.catch(() => {});
	}, []);

	const fetchCategoryTree = async () => {
		try {
			setLoading(true);
			const response = await fetch("/api/categories?includeChildren=true");
			const data = await response.json();
			const categories = data.categories || [];
			setFullCategoryTree(categories);
			
			// Initial stack: Main level
			setNavigationStack([
				{
					categories: categories,
					title: "Meniu",
					level: 0,
					breadcrumb: [],
				},
			]);
		} catch (error) {
			console.error("Error fetching category tree:", error);
		} finally {
			setLoading(false);
		}
	};

	const buildCategoryUrl = (breadcrumb, currentSlug) => {
		const slugs = [...breadcrumb.map((b) => b.slug), currentSlug];
		return `/${slugs.join("/")}`;
	};

	const handleCategoryClick = (category, e) => {
		e.preventDefault();
		e.stopPropagation();

		const children = category.children || [];
		const currentBreadcrumb = navigationStack[navigationStack.length - 1].breadcrumb || [];

		if (children.length > 0) {
			const nextBreadcrumb = [...currentBreadcrumb, { slug: category.slug, name: category.name }];
			setNavigationStack((prev) => [
				...prev,
				{
					categories: children,
					title: category.name,
					parentCategory: category,
					level: prev.length,
					breadcrumb: nextBreadcrumb,
				},
			]);
		} else {
			const url = buildCategoryUrl(currentBreadcrumb, category.slug);
			router.push(url);
			// Închidem meniul (Bootstrap style)
			const offcanvas = document.getElementById('mobileMenu');
			if (offcanvas) {
				const bsOffcanvas = window.bootstrap?.Offcanvas?.getInstance(offcanvas);
				if (bsOffcanvas) bsOffcanvas.hide();
			}
		}
	};

	const handleLinkClick = (url) => {
		router.push(url);
		const offcanvas = document.getElementById('mobileMenu');
		if (offcanvas) {
			const bsOffcanvas = window.bootstrap?.Offcanvas?.getInstance(offcanvas);
			if (bsOffcanvas) bsOffcanvas.hide();
		}
	};

	const handleBack = () => {
		setNavigationStack((prev) => prev.slice(0, -1));
	};

	const handleDepoziteClick = () => {
		setNavigationStack((prev) => [
			...prev,
			{
				type: "depozite",
				categories: [],
				title: "Depozite",
				level: prev.length,
				breadcrumb: [],
			},
		]);
	};

	const currentView = navigationStack[navigationStack.length - 1] || {
		categories: [],
		title: "Meniu",
		breadcrumb: [],
	};
	const isMainLevel = navigationStack.length <= 1;

	return (
		<div className='offcanvas offcanvas-start canvas-mb' id='mobileMenu' style={{ width: "320px" }}>
			<span className='icon-close icon-close-popup' data-bs-dismiss='offcanvas' aria-label='Close' />
			
			<div className='mb-canvas-content d-flex flex-column h-100'>
				{/* Header fix tip premium */}
				<div className='mb-menu-header sticky-top bg-white border-bottom' style={{ padding: "12px 16px", zIndex: 10 }}>
					<div className='d-flex align-items-center gap-3'>
						{!isMainLevel && (
							<button onClick={handleBack} className='btn-back p-0 border-0 bg-transparent' style={{ fontSize: "20px" }}>
								<i className="icon-arrow-left" style={{ fontSize: "18px" }}>←</i>
							</button>
						)}
						<h5 className='mb-0 fw-bold' style={{ fontSize: "16px", color: "#111" }}>
							{currentView.title}
						</h5>
					</div>
				</div>

				<div className='mb-body flex-grow-1 overflow-auto custom-scrollbar-mb'>
					{loading ? (
						<div className="p-5 text-center text-muted">
							<div className="spinner-border spinner-border-sm me-2" role="status"></div>
							Se încarcă...
						</div>
					) : (
						<ul className='nav-ul-mb p-0 m-0 list-unstyled'>
							{/* Link-uri principale doar la nivelul 0 */}
							{isMainLevel && (
								<>
									<li className='border-bottom'>
										<a onClick={() => handleLinkClick("/")} className='d-flex align-items-center gap-3 p-3 text-dark' style={{ cursor: "pointer", textDecoration: "none" }}>
											<i className="icon-home" style={{ fontSize: "18px", opacity: 0.7 }} />
											<span style={{ fontSize: "14px", fontWeight: "500" }}>Acasă</span>
										</a>
									</li>
									<li className='border-bottom'>
										<a onClick={() => handleLinkClick("/toate-produsele")} className='d-flex align-items-center gap-3 p-3 text-dark' style={{ cursor: "pointer", textDecoration: "none" }}>
											<i className="icon-bag" style={{ fontSize: "18px", opacity: 0.7 }} />
											<span style={{ fontSize: "14px", fontWeight: "500" }}>Magazin</span>
										</a>
									</li>
									{depots.length > 0 && (
										<li className='border-bottom'>
											<a onClick={handleDepoziteClick} className='d-flex align-items-center justify-content-between p-3 text-dark' style={{ cursor: "pointer", textDecoration: "none" }}>
												<div className='d-flex align-items-center gap-3'>
													<i className="icon-stores" style={{ fontSize: "18px", opacity: 0.7 }} />
													<span style={{ fontSize: "14px", fontWeight: "500" }}>Depozite</span>
												</div>
												<span style={{ fontSize: "16px", color: "#ccc" }}>›</span>
											</a>
										</li>
									)}
									<li className='border-bottom'>
										<a onClick={() => handleLinkClick("/craciun")} className='d-flex align-items-center gap-3 p-3' style={{ cursor: "pointer", textDecoration: "none", color: "#c0392b" }}>
											<span style={{ fontSize: "18px" }}>🎄</span>
											<span style={{ fontSize: "14px", fontWeight: "600" }}>Crăciun</span>
										</a>
									</li>
									<li className='border-bottom'>
                                                  <a onClick={() => handleLinkClick("/reduceri")} className='d-flex align-items-center gap-3 p-3' style={{ cursor: "pointer", textDecoration: "none", color: "#d93025" }}>
                                                       <i className="icon-flash" style={{ fontSize: "18px", opacity: 1 }} />
                                                       <span style={{ fontSize: "14px", fontWeight: "600" }}>Reduceri</span>
                                                  </a>
                                             </li>
								</>
							)}

							{/* Lista depozite */}
							{currentView.type === "depozite" &&
								depots.map((depot, i) => (
									<li key={i} className='border-bottom'>
										<a onClick={() => handleLinkClick(`/depozite/${depot.slug}`)} className='d-flex align-items-center gap-3 p-3 text-dark' style={{ cursor: "pointer", textDecoration: "none" }}>
											<span style={{ fontSize: "14px", fontWeight: "400", color: "#333" }}>{depot.label}</span>
										</a>
									</li>
								))}

							{/* Lista categorii */}
							{currentView.type !== "depozite" && currentView.categories.map((item) => {
								const hasChildren = item.children && item.children.length > 0;
                                        const hasSubChildren = item.subChildren && item.subChildren.length > 0;

								return (
									<li key={item.id} className='border-bottom'>
										{/* Dacă suntem la nivelul 1 (subcategorii), afișăm subcategoria și copiii ei imediat dedesubt (ca pe desktop) */}
										{!isMainLevel && currentView.level === 1 ? (
											<div className="p-3">
												<div 
                                                            className="fw-bold mb-2 text-dark d-flex justify-content-between align-items-center" 
                                                            style={{ fontSize: "14px", cursor: "pointer" }}
                                                            onClick={() => handleLinkClick(buildCategoryUrl(currentView.breadcrumb, item.slug))}
                                                       >
													{item.name}
                                                            <i style={{ fontSize: "10px", opacity: 0.5 }}>Vezi tot ›</i>
												</div>
												{hasSubChildren && (
													<ul className="list-unstyled ps-2 border-left">
														{item.subChildren.map(subItem => (
															<li key={subItem.id} className="py-1">
																<a 
                                                                                onClick={() => handleLinkClick(buildCategoryUrl([...currentView.breadcrumb, {slug: item.slug}], subItem.slug))}
                                                                                className="text-muted" 
                                                                                style={{ fontSize: "13px", cursor: "pointer", textDecoration: "none" }}
                                                                           >
																	{subItem.name}
																</a>
															</li>
														))}
													</ul>
												)}
											</div>
										) : (
                                                       /* Nivelul 0 (Categorii principale) */
											<div
												onClick={(e) => handleCategoryClick(item, e)}
												className='d-flex align-items-center justify-content-between p-3'
												style={{ cursor: "pointer", transition: "all 0.2s" }}
											>
												<div className='d-flex align-items-center gap-3'>
													<span style={{ fontSize: "14px", fontWeight: "400", color: "#333" }}>{item.name}</span>
												</div>
												{hasChildren && (
													<span style={{ fontSize: "16px", color: "#ccc" }}>›</span>
												)}
											</div>
										)}
									</li>
								);
							})}
                                   
                                   {isMainLevel && (
                                        <>
                                             <li className='border-bottom'>
                                                  <a onClick={() => handleLinkClick("/contact")} className='d-flex align-items-center gap-3 p-3 text-dark' style={{ cursor: "pointer", textDecoration: "none" }}>
                                                       <i className="icon-mail" style={{ fontSize: "18px", opacity: 0.7 }} />
                                                       <span style={{ fontSize: "14px", fontWeight: "500" }}>Contact</span>
                                                  </a>
                                             </li>
                                        </>
                                   )}
						</ul>
					)}
				</div>

				{/* Footer fix tip premium */}
				<div className='mb-bottom bg-light border-top mt-auto' style={{ padding: "16px" }}>
					<a
						onClick={() => handleLinkClick("/autentificare")}
						className='d-flex align-items-center gap-3 text-dark'
						style={{ textDecoration: "none", cursor: "pointer" }}>
						<i className='icon icon-account' style={{ fontSize: "20px", color: "#007bff" }} />
						<span style={{ fontSize: "14px", fontWeight: "600" }}>Contul meu</span>
					</a>
				</div>
			</div>

			<style jsx>{`
				.border-left {
					border-left: 2px solid #f0f0f0;
					margin-left: 4px;
				}
				.custom-scrollbar-mb::-webkit-scrollbar {
					width: 4px;
				}
				.custom-scrollbar-mb::-webkit-scrollbar-track {
					background: #f1f1f1;
				}
				.custom-scrollbar-mb::-webkit-scrollbar-thumb {
					background: #ccc;
					border-radius: 10px;
				}
				.nav-ul-mb li:active {
					background-color: #f9f9f9;
				}
			`}</style>
		</div>
	);
}
